div<template>
  <div class="modal-produto-item">
    <h3>NOME DO PRODUTO <span>*</span></h3>
    <CenarioInput
      tipo="texto"
      maxlength="300"
      placeholder="Insira o Nome do Produto"
      nome="nome"
      :validaCampos="validaCampos"
      :exibeValidacao="exibeValidacao"
      :model="nome"
      @update:model="update => this.calculaProdutosForm(update, 'nome')"
    />
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";

export default {
  name: "ModalProdutoDescricao",
  components: { CenarioInput },
  inject: ["calculaProdutosForm"],
  props: {
    exibeValidacao: Boolean,
    validaCampos: Object,
    produtosForm: Object
  },
  data() {
    return {
      nome: ""
    };
  },
  created() {
    this.$nextTick(() => {
      this.updateDados();
    });
  },
  watch: {
    produtosForm: {
      deep: true,
      handler() {
        this.updateDados();
      }
    }
  },
  methods: {
    updateDados() {
      this.nome = this.produtosForm.nome;
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
  span {
    color: red;
  }
}
.bloco-divisao {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 10px 10px;
}
.bloco-divisao-grupo {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  gap: 10px 10px;
}
.modal-produto-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
